import notificationService from "../v-components/ui/notification/notification-service";

export default notificationService;
